import { FormControl, Input, InputAdornment, InputLabel } from "@mui/material";
import User from "../../../../../assets/Images/user1.png";

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const UsernameField = ({ value, onChange, onKeyPress }: Props) => (
  <FormControl sx={{ mt: 2 }} variant="standard" fullWidth>
    <InputLabel htmlFor="username">Username</InputLabel>
    <Input
      id="username"
      value={value}
      onChange={onChange}
      placeholder="Enter your username"
      onKeyPress={onKeyPress}
      disableUnderline
      sx={{
        "& input::placeholder": {
          fontSize: "12px",
          color: "#999", 
          opacity: 1,
        },
      }}
      startAdornment={
        <InputAdornment position="start">
          <img src={User} className="loginFieldIcon" alt="" />
        </InputAdornment>
      }
    />
  </FormControl>
);

export default UsernameField;
